"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eleven/sections/chooseusSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ChooseusSection336sItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "2s" | "3s" | "4s" */
    dataWowDuration: string;
    /** Detected variants: "/Templates/Doccure/img/category/choose-img-1.jpg" | "/Templates/Doccure/img/category/choose-img-2.jpg" | "/Templates/Doccure/img/category/choose-img-3.jpg" | "/Templates/Doccure/img/category/choose-img-4.jpg" */
    src: string;
    /** Detected variants: "Expert Guidance" | "Personalized Care" | "Trusted Brands" | "Smooth Experience" */
    link0Text: ReactNode;
    /** Detected variants: "Expert dermatologist guidance for safe, cosmetic treatment results." | "AI-powered skin analysis delivers tailored product recommendations." | "Carefully curated, high quality cosmetic and skincare products." | "Enjoy fast delivery, simple returns, and transparent customer reviews." */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-3 col-lg-3 col-sm-6" */
    className?: string;
    /** Detected variants: "choose-item-eleven wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "choose-overlay" */
    div0ClassName2?: string;
    /** Detected variants: "choose-img" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "choose-icon" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "isax isax-arrow-right-1" */
    i0ClassName?: string;
    /** Detected variants: "choose-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "#" */
    link0Href?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "" */
    div0div1h30Expr0?: ReactNode;
    /** Detected variants: "" */
    div0div1p0Expr1?: ReactNode;
};
export type HomeElevenChooseusSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ChooseusSection336sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ChooseusSection336sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ChooseusSection336sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ChooseusSection336sItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "Why Choose Us?" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "arrow" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/arrow-left.svg" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "arrow" */
    sectionDiv0Div0Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/arrow-right.svg" */
    sectionDiv0Div0Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "What Makes Us Different" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    sectionDiv0Div1ClassName?: string;
    /** Default: "icon" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/category/choose-icon-1.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    chooseusSection336s: ChooseusSection336sItem[];
    chooseusSection336sItemWrapper?: (item: ChooseusSection336sItem, content: ReactNode) => ReactNode;
    chooseusSection336sRenderer?: (defaultNode: ReactNode) => ReactNode;
    chooseusSection336sLinkVisible?: boolean;
    chooseusSection336sLinkRenderer?: (item: ChooseusSection336sItem, defaultNode: ReactNode) => ReactNode;
    chooseusSection336sImageVisible?: boolean;
    chooseusSection336sImageRenderer?: (item: ChooseusSection336sItem, defaultNode: ReactNode) => ReactNode;
    chooseusSection336sH3Visible?: boolean;
    chooseusSection336sH3Renderer?: (item: ChooseusSection336sItem, defaultNode: ReactNode) => ReactNode;
    chooseusSection336sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ChooseusSection336sItem) => Partial<ComponentProps<typeof SmartLink>>);
    chooseusSection336sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ChooseusSection336sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    chooseusSection336sH3Props?: Partial<ComponentProps<"h3">> | ((item: ChooseusSection336sItem) => Partial<ComponentProps<"h3">>);
};

const HomeElevenChooseusSectionGenerated: FC<HomeElevenChooseusSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Why Choose Us?",
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt = "arrow",
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/arrow-left.svg",
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0ImageWithBasePath1ImageAlt = "arrow",
    sectionDiv0Div0Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/arrow-right.svg",
    sectionDiv0Div0Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div0H20H2Text = "What Makes Us Different",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionImageWithBasePath0ImageAlt = "icon",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/category/choose-icon-1.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    sectionDiv0Div1ClassName,
    chooseusSection336s,
    chooseusSection336sItemWrapper,
    chooseusSection336sRenderer,
    chooseusSection336sLinkVisible,
    chooseusSection336sLinkRenderer,
    chooseusSection336sImageVisible,
    chooseusSection336sImageRenderer,
    chooseusSection336sH3Visible,
    chooseusSection336sH3Renderer,
    chooseusSection336sLinkProps,
    chooseusSection336sImageProps,
    chooseusSection336sH3Props,
}) => {
    return (
        <section className="whychoose-section-eleven section">
            <div className="container">
                <div className="section-header section-header-eleven text-center">
                    <div className="title">
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid icon-1" {...(sectionDiv0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                        {sectionDiv0Div0Div0DivText}
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0Div0ImageWithBasePath1ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath1ImageAlt} className="img-fluid icon-2" {...(sectionDiv0Div0Div0ImageWithBasePath1ImageProps ?? {})} />
                        ))}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-5"}>
                    {renderCollectionNode(
                        chooseusSection336s,
                        (item: ChooseusSection336sItem) => (
                            <div className={item.className ?? "col-xl-3 col-lg-3 col-sm-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "choose-item-eleven wow fadeInUp"} data-wow-duration={item.dataWowDuration}>
                                    <div className={item.div0ClassName2 ?? "choose-overlay"}>
                                        {renderItemNode(chooseusSection336sImageVisible, chooseusSection336sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "choose-img"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof chooseusSection336sImageProps === "function" ? chooseusSection336sImageProps(item) : (chooseusSection336sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                        {renderItemNode(chooseusSection336sLinkVisible, chooseusSection336sLinkRenderer, item, (
                                            <SmartLink href={item.href ?? "#"} className={item.link0ClassName ?? "choose-icon"} {...(typeof chooseusSection336sLinkProps === "function" ? chooseusSection336sLinkProps(item) : (chooseusSection336sLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>
                                                <i className={item.i0ClassName ?? "isax isax-arrow-right-1"} />
                                            </SmartLink>
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "choose-content"}>
                                        {renderItemNode(chooseusSection336sH3Visible, chooseusSection336sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof chooseusSection336sH3Props === "function" ? chooseusSection336sH3Props(item) : (chooseusSection336sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {" "}
                                                {renderItemNode(chooseusSection336sLinkVisible, chooseusSection336sLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href ?? "#"} {...(typeof chooseusSection336sLinkProps === "function" ? chooseusSection336sLinkProps(item) : (chooseusSection336sLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                    </div>
                                </div>
                            </div>
                        ),
                        chooseusSection336sItemWrapper,
                        chooseusSection336sRenderer
                    )}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-1" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeElevenChooseusSectionGenerated;
